import courseTypes from 'constants/courseTypes';
import pluginTypes from 'constants/pluginTypes';

export const getColor = (color, theme) => {
  switch (color) {
    case 'course':
      return theme['color.purpleLight'];
    case 'lesson':
      return theme['color.blueLight'];
    default:
      return 'rgba(0,0,0,0.4)';
  }
};

export const getIcon = (icon) => {
  switch (icon) {
    case 'course':
      return 'duotoneCourse';
    case 'lesson':
      return 'duotoneLesson';
    default:
      return 'duotoneFile';
  }
};

export const getCourseWareNameFromPlugin = (plugin) => {
  if (plugin.type === pluginTypes.COURSE) {
    const pluginList = {
      "Bronte Viewer eText Plugin": "Bronte Viewer",
      "Pearson eText course plugin": "ePub",
    };
    return pluginList[plugin.name] || null;
  } else {
    if (plugin.type === pluginTypes.LESSON && plugin.name === "Lab Lesson") {
      return courseTypes.ilab;
    }
    return null;
  }
}; 
